





















































import Vue from 'vue'
import { mapGetters, mapMutations } from 'vuex'

import tableContainer from '@/components/common/tables/table-container.vue'
import simpleTable from '@/components/common/tables/simple-table/simple-table.vue'
import searchPriceSetting from '@/components/root-components/search-price-setting/search-price-setting.vue'
import selectSimple from '@/components/controls/select/select-simple.vue'

import * as http from '@/utils/http'

import tabSwitcher from '@/components/root-components/product-price-setting/_common/tab-switcher.vue'
import buttonRed from '@/components/common/click/button/button-red.vue'

import config from '@/config'

import { PriceSettingsForTable, PriceSettings } from '@/types/price-settings'
import { CellHeader } from '@/types/table'
import { CategoryType } from '@/types/product/CategoryType';

import style from './style.module.scss'

export default Vue.extend({
    name: 'product-price-setting',
    components: {
        simpleTable,
        tableContainer,
        searchPriceSetting,
        tabSwitcher,
        buttonRed,
        selectSimple
    },
    props: {
        productId: Number
    },
    mounted() {
        this.get();
    },
    data() {
        return {
            style: style,
            gridShow: false,
            showPickUpTable: false,
            keyword: '',
            supplierListUrl: config.marketSiteUrl + '/Merchant/Supplier',
            saveResponse: null,
            saving: false,
            message: '',
            messageInfo: '',
            CategoryType: CategoryType,
            taxPercentList: [
                { id: null, value: 'Не установлен'},
                { id: 0, value: '0%'},
                { id: 10, value: '10%'},
                { id: 20, value: '20%'},
            ],
            ByAgreement: false,
        }
    },
    methods: {
        ...mapMutations(["setDeliveryTaxPercent"]),
        async get() {
            this.$store.dispatch('getPickupPriceSettings', this.productId);
            await this.$store.dispatch('getDeliveryPriceSettings', this.productId);

            if(this.deliveryPriceSettings && this.deliveryPriceSettings.list && this.deliveryPriceSettings.list.length) {
                const rootItem = this.deliveryPriceSettings.list[0];
                this.rootToggle(rootItem, 'delivery')
            }
        },
        async save() {
            this.clearMessageNow();
            this.clearErrorType();
            this.saving = true;
            
            if(this.showPickUpTable) {

                if(!this.pickupPriceSettings.list) {
                    this.setNoDataMessage();
                    return;
                }

                //после сохранения снова забираем данные
                if(await this.savePickup()) {
                    await this.$store.dispatch('getPickupPriceSettings', this.productId);
                    this.setSuccessMessage();
                    if(this.pickupPriceSettings.list.length) this.rootToggle(this.pickupPriceSettings.list[0], 'pickup')
                }
                else {
                    this.message = 'Произошла ошибка при сохранении данных скидок для самовывоза';
                }
            }
            else {
                if(!this.deliveryPriceSettings.list) {
                    this.setNoDataMessage();
                    return
                }
                if(await this.saveDelivery()) {
                    await this.$store.dispatch('getDeliveryPriceSettings', this.productId);
                    this.setSuccessMessage();
                    if(this.deliveryPriceSettings.list.length) this.rootToggle(this.deliveryPriceSettings.list[0], 'delivery')
                }
                else {
                    this.message = 'Произошла ошибка при сохранении данных скидок для доставки'
                }
            }
            this.clearMessage();
            this.saving = false;
        },
        rootToggle(row: PriceSettings, typeCode: string) {
            this.$store.dispatch('toggle', { row: row, typeCode: typeCode})
        },
        async saveDelivery(): Promise<boolean> {
            const response = await this.$store.dispatch('saveDeliveryPriceSettings', this.productId);
            
            return response && http.isSuccess(response);
        },
        async savePickup(): Promise<boolean> {
            const response = await this.$store.dispatch('savePickupPriceSettings', this.productId);

            return response && http.isSuccess(response);
        },
        //hasCheckedElement(){
        //    return this.deliveryPriceSettings.list.some((element)=>element.IsChecked);
        //},
        setNoDataMessage() {
            this.messageInfo = 'Нет данных для сохранения';
            this.saving = false;
            this.clearMessage();
        },
        setSuccessMessage() {
            this.messageInfo = 'Данные успешно сохранены';
        },
        clearMessage() {
            setTimeout(() => this.messageInfo = '', 10000);
            setTimeout(() => this.message = '', 10000);
        },
        clearMessageNow() {
            this.messageInfo = '';
            this.message = '';
        },
        clearErrorType(){
            const errorType1 = document.getElementsByClassName("errorType1");
            if(errorType1 instanceof HTMLCollection)
            {
                errorType1[0].innerHTML="";
            }
        },
        setKeyword(keyword: string): void {
            this.keyword = keyword;
            if(this.showPickUpTable) {
                this.$store.dispatch('searchPickup', keyword);
            } else {
                this.$store.dispatch('searchDelivery', keyword);
            }
        },
        switchTable(tabName: string): void {
            this.showPickUpTable = tabName === 'pickup';
        },
        addUnitNameToHeader(header: CellHeader): CellHeader {
            const unitName = this.$store.getters.getUnitName.unitName;
            if (header.name.indexOf('объем') > -1 && this.selectedCategoryType === CategoryType.Product) {
                header.unitName = unitName;
            }
            return header;
        },
        checkByAgreement(val: boolean){
            this.ByAgreement = val;
        }
    },
    computed: {
        ...mapGetters([
            "selectedCategoryType",
            "deliveryTaxPercent"
        ]),

        deliveryPriceSettings(): PriceSettingsForTable {
            const settings = this.$store.getters.getDeliveryPriceSettingsForTable;
            const unitName = this.$store.getters.getUnitName.unitName;

            if (unitName && this.selectedCategoryType === CategoryType.Product) {
                settings.columnsHeaders = settings.columnsHeaders.map(this.addUnitNameToHeader);
            }
            if(settings.list) {
                if(settings.list[0].Cells.length == 1) {
                    this.checkByAgreement(true);
                } else {
                    this.checkByAgreement(false);
                }
            }
            return settings;
        },
        pickupPriceSettings(): PriceSettingsForTable {
            const settings = this.$store.getters.getPickupPriceSettingsForTable;     
            const unitName = this.$store.getters.getUnitName.unitName;
            if (unitName && this.selectedCategoryType === CategoryType.Product) {
                settings.columnsHeaders = settings.columnsHeaders.map(this.addUnitNameToHeader);
            }
            return settings;
        },
        anyDeliveryRowFilled(): boolean {
            return this.deliveryPriceSettings && this.deliveryPriceSettings.list
                ? this.deliveryPriceSettings.list.some((item) => item.AnyChildFilled)
                : false;
        }
    }
})
